import {
    EyeIcon,
    TrashIcon,
    PencilIcon, CheckCircleIcon, XCircleIcon, SaveIcon
} from '@heroicons/react/outline'
import {activeBucket_, loadingText_} from "../../App";
import {useRef, useState} from "react";
import {useRecoilState} from "recoil";
import {v56a_createBucketUser, v56a_deleteBucketUser, v56a_getBucketUsers, v56a_saveAccessDescription} from "../../v56_api";
import V56spinner from "../../components/loaderIndicators/v56_spinner";
import React from "react";
import {useEffect} from "react";


export default function V56AccessList() {

    let editBucketDescription = useRef(null);
    const [activeCredential, setActiveCredential] = useState(null);
    const [activeBucket, setActiveBucket] = useRecoilState(activeBucket_);
    const [users, setUsers] = useState([]);
    const [bUsername, setBUserName] = useState('');
    const [bPassword, setBPassword] = useState('');
    const [showCredentials, setShowCredentials] = useState(false);
    const [editingUserDescription, setEditingUserDescription] = useState(false);
    const [userDescription, setUserDescription] = useState('');
    const [showSpinner, setShowSpinner] = useState(false);
    const [loadingText, setLoadingText] = useRecoilState(loadingText_);

    useEffect(() => {
        setLoadingText('Loading access keys...');
        setShowSpinner(true);
        (async () => {
            const response = await v56a_getBucketUsers(activeBucket.id);
            if (response.status === 200) {
                setShowSpinner(false);
                setUsers(response.data);
            }
        })();
    },[]);

    /**
     * Combines multiple class strings to one
     * @param classes
     * @returns {string}
     */
    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }

    function renderEditBucketDescription(user) {
        return (
        <div className="flex-1">
            <input
                type="text"
                maxLength={200}
                autoFocus={true}
                ref={editBucketDescription}
                defaultValue={user.description}
                onChange={(e) => setUserDescription(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        saveUserDescription(user.id);
                    }
                }}
                name="bucket-user-description"
                id="bucket-user-description"
                className="block w-full focus:border-[#5f2881] focus:ring-[#5f2881] border-gray-300 rounded-md"
            />
        </div>
        )
    }

    function renderBucketDescription(user) {
            return (
                <div className="flex-1 truncate p-4">
                    <p className="text-gray-500 text-sm truncate" title={user.description}>{user.description?user.description:'This access key has no description'}</p>
                </div>
            )
    }

    function renderEditButton(userId) {
        return (
            <a
                href='#'
                onClick={() => {
                    setEditingUserDescription(userId);
                }}
                className="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500"
            >
                <PencilIcon className="w-5 h-5 text-gray-400" aria-hidden="true"/>
                <span className="ml-3">Edit</span>
            </a>
        )
    }

    function renderCancelEditButton() {
        return (
            <a
                href='#'
                onClick={() => {
                    setEditingUserDescription(false);
                }}
                className="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500"
            >
                <XCircleIcon className="w-5 h-5 text-gray-400" aria-hidden="true"/>
                <span className="ml-3">Cancel</span>
            </a>
        )
    }

    /**
     * Save user description
     * @param userId
     * @returns {Promise<void>}
     */
    async function saveUserDescription(userId) {
        setLoadingText('Saving...');
        setShowSpinner(true);
        const result = await v56a_saveAccessDescription(userId, activeBucket.id, userDescription);
        if (result.status === 200) {
            setEditingUserDescription(false);
            // Change user description
            const newUsers = users.map(user => {
                if (user.id === userId) {
                    user.description = userDescription;
                }
                return user;
            });
            setUsers(newUsers);
        }
        setShowSpinner(false);
    }

    function renderEditDescriptionSaveButton(user) {
        return (
            <a
                href='#'
                onClick={() => saveUserDescription(user.id)}
                className="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500"
            >
                <SaveIcon className="w-5 h-5 text-gray-400" aria-hidden="true"/>
                <span className="ml-3">Save</span>
            </a>
        )
    }

    function renderDeleteButton(user) {
        return (
            <a
                href='#'
                onClick={() => deleteBucketUser(user.id)}
                className="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500"
            >
                <TrashIcon className="w-5 h-5 text-red-500" aria-hidden="true"/>
                <span className="ml-3 text-red-500">Delete</span>
            </a>
        )
    }

    const renderAccessList = React.useCallback(() => {
        return (
            <ul role="list" className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-2">
                <button
                    type="button"
                    className="relative block w-full border-2 border-gray-300 border-dashed rounded-lg text-center hover:border-gray-400"
                    onClick={createNewBucketUser}
                >
                    <svg
                        className="mx-auto h-12 w-12 text-gray-400 mt-5"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 330.87 329.87"
                    >

                        <path d="M230.74677,191.48541h7.50219c.81461,0,1.47498,.66037,1.47498,1.47498v35.65545c0,.81461,.66037,1.47498,1.47498,1.47498h35.65545c.81461,0,1.47498,.66037,1.47498,1.47498v7.50333c0,.81461-.66037,1.47498-1.47498,1.47498h-35.65545c-.81461,0-1.47498,.66037-1.47498,1.47498v35.65545c0,.81461-.66037,1.47498-1.47498,1.47498h-7.50219c-.81461,0-1.47498-.66037-1.47498-1.47498v-35.65545c0-.81461-.66037-1.47498-1.47498-1.47498h-35.65545c-.81461,0-1.47498-.66037-1.47498-1.47498v-7.50333c0-.81461,.66037-1.47498,1.47498-1.47498h35.65545c.81461,0,1.47498-.66037,1.47498-1.47498v-35.65545c0-.81461,.66037-1.47498,1.47498-1.47498Z"/>
                        <path d="M65.62496,279.14953H10.51807c-5.80908,0-10.51807-4.70951-10.51807-10.51807v-56.6276c0-2.78205,1.10214-5.4506,3.06503-7.42171L85.43623,121.86173c-1.97008-7.81511-2.96591-15.83925-2.96591-23.93221C82.47031,43.93093,126.40175,0,180.40035,0s97.929,43.93093,97.929,97.92952-43.93041,97.92952-97.929,97.92952c-7.40887,0-14.7746-.83713-21.97445-2.49342l-27.21551,27.21603c-1.97265,1.97214-4.64788,3.08044-7.43763,3.08044h-19.5062v18.7461c0,5.80856-4.70899,10.51807-10.51807,10.51807h-17.60545v15.70521c0,5.80856-4.70899,10.51807-10.51807,10.51807Zm-44.58882-21.03614H55.10689v-15.70521c0-5.80856,4.70899-10.51807,10.51807-10.51807h17.60545v-18.7461c0-5.80908,4.70899-10.51807,10.51807-10.51807h25.66759l28.40907-28.40958c2.73532-2.73532,6.75201-3.75066,10.4585-2.63722,7.17776,2.1524,14.6195,3.24376,22.11671,3.24376,42.39892,0,76.89286-34.49445,76.89286-76.89337S222.79927,21.03614,180.40035,21.03614,103.50646,55.53059,103.50646,97.92952c0,8.07344,1.26135,16.05701,3.74912,23.72986,1.21718,3.75271,.23162,7.87058-2.55197,10.66598L21.03614,216.34771v41.76568Z"/>
                        <path d="M210.80415,108.44759c-5.80856,0-10.51807-4.70899-10.51807-10.51807,0-10.96488-8.92085-19.88573-19.88573-19.88573-5.80856,0-10.51807-4.70899-10.51807-10.51807s4.70951-10.51807,10.51807-10.51807c22.56455,0,40.92187,18.35732,40.92187,40.92187,0,5.80908-4.70951,10.51807-10.51807,10.51807Z"/>
                    </svg>
                    <span className="mt-2 mb-2 block text-sm font-medium text-gray-900">Click here to add a new access key</span>
                </button>
                {users.map((user) => (
                    <li key={user.id} className="col-span-1 bg-white rounded-lg shadow divide-y divide-gray-200">
                        <div className="float-left p-4">
                            <p className="text-sm text-gray-400">
                                Access key
                            </p>
                            <span className="text-black">{user.username}</span>
                        </div>
                        <div className="w-full flex items-center justify-between space-x-6">
                            {editingUserDescription === user.id?renderEditBucketDescription(user):renderBucketDescription(user)}
                        </div>
                        <div>
                            <div className="-mt-px flex divide-x divide-gray-200">
                                <div className="w-0 flex-1 flex">
                                    {editingUserDescription === user.id?renderCancelEditButton():renderEditButton(user.id)}
                                </div>
                                <div className="-ml-px w-0 flex-1 flex">
                                    {editingUserDescription === user.id?renderEditDescriptionSaveButton(user):renderDeleteButton(user)}
                                </div>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        )
    }, [users, showCredentials, editingUserDescription, userDescription]);

    function createNewBucketUser() {
        setLoadingText("Creating new access key...");
        setShowSpinner(true);

        /* Create new bucket user */
        v56a_createBucketUser(
            activeBucket.id,
        ).then(response => {
            if (typeof response === 'undefined') {
                setShowSpinner(false);
            }
            if (response.status === 201) {
                const newUser = response.data;
                const password = newUser.password;
                newUser.password = '';
                newUser.created_date = new Date();
                const newUsers = [...users, response.data];
                setUsers(newUsers);
                setBUserName(newUser.username);
                setBPassword(password);
                setShowCredentials(true);
            }
            setShowSpinner(false);
        })
    }

    function deleteBucketUser(user_id) {
        setLoadingText("Deleting access key...");
        setShowSpinner(true);

        /* Delete bucket user */
        v56a_deleteBucketUser(
            user_id,
        ).then(response => {
            if (typeof response === 'undefined') {
                setShowSpinner(false);
            }
            if (response.status === 200) {
                const newUsers = users.filter(user => user.id !== user_id);
                setUsers(newUsers);
            }
            setShowSpinner(false);
        })
    }

    if (showCredentials) {
        return (
            <div className="rounded-md bg-green-50 p-4">
                <div className="flex">
                    <div className="flex-shrink-0">
                        <CheckCircleIcon className="h-5 w-5 text-green-400" aria-hidden="true" />
                    </div>
                    <div className="ml-3">
                        <h3 className="text-lg font-medium text-green-800">New access key created</h3>
                        <div className="mt-2 text-sm text-green-700">
                            <p className="mb-5">These are the new credentials. You will not be able to see the secret again.</p>
                            <p><b>Bucket name:</b> {activeBucket.bucket_name}</p>
                            <p><b>Bucket ID:</b> {activeBucket.id}</p>
                            <p><b>Access key:</b> {bUsername}</p>
                            <p><b>URL:</b> https://v.vault56.com</p>
                            <p className="mb-10"><b>Secret:</b> {bPassword}</p>
                        </div>
                        <div className="mt-4">
                            <div className="-mx-2 -my-1.5 flex">
                                <button
                                    type="button"
                                    className="ml-3 bg-red-300 px-2 py-1.5 rounded-md text-sm font-medium text-black hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600"
                                    onClick={() => {
                                        setBPassword('');
                                        setBUserName('');
                                        setShowCredentials(false);
                                    }}
                                >
                                    Dismiss
                                </button>
                                <button
                                    type="button"
                                    className="ml-3 bg-green-200 px-2 py-1.5 rounded-md text-sm font-medium text-black hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600"
                                    onClick={() => {
                                        navigator.clipboard.writeText(
                                            'Bucket name: ' + activeBucket.bucket_name + '\n' +
                                            'Bucket ID: ' + activeBucket.id + '\n' +
                                            'Access key: ' + bUsername + '\n' +
                                            'Secret: ' + bPassword);
                                    }}
                                >
                                    Copy credentials to clipboard
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    } else if (showSpinner) {
      return <V56spinner/>
    } else {
        return renderAccessList();
    }
}
